import { BuyNowButton } from '../EventHeader/BuyNowButton'
import { EventDocent } from './EventDocent'
import { VideoTeaser } from './VideoTeaser'
import { VideoStructureAccordion } from './VideoStructureAccordion'
import styles from './eventBody.module.scss'

export const EventContentPreview = () => {
  return (
    <>
      <div className="container-fluid bg4s">
        <div className="row">
          <div className="container">
            <div className="row bgwhi" style={{ borderBottomLeftRadius: '0.6em', borderBottomRightRadius: '0.6em', padding: '0' }}>
              <div className="hidden-xs trenner" style={{ marginBottom: '25xp' }} />
              <div style={{ display: 'flex', alignItems: 'stretch' }} className={styles.flexContainer}>
                <div style={{ flex: '1 1 60%', paddingLeft: '10px', paddingRight: '20px' }}>
                  <VideoStructureAccordion />
                </div>
                <div style={{ flex: '1 1 40%', paddingRight: '20px', paddingLeft: '20px', display: 'flex', flexDirection: 'column' }}>
                  <div style={{ padding: '15px', boxShadow: 'rgba(0, 0, 0, 0.1) 0px 4px 8px, rgba(0, 0, 0, 0.1) -2px 3px 9px 5px', minWidth: '320px' }}>
                    <div>
                      <VideoTeaser />
                      <EventDocent />
                    </div>

                    <BuyNowButton style={{ marginTop: '10px', width: '100%', borderRadius: '10px', fontSize: '16px' }} />
                  </div>
                </div>
              </div>

              <div className="hidden-xs col-sm-12 padt-3"></div>
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
